import { ForemanDB } from '../../types/IndexedDB/ForemanDB'
import { TimeSheet } from '../../types/Reports/ShiftEnd/TimeSheet'
import { Activity } from '../../types/Reports/ShiftEnd/Activity'
import { showErrorToast } from '../CommonServices/alertServices'
import {
	ShiftEndWorkItemsSummary,
	ShiftEndTaskSummary,
} from '../../types/Reports/ShiftEnd/ShiftEndWorkItems'

export const mapTimeSheets = async (db: ForemanDB, newTimeSheets: TimeSheet[]) => {
	try {
		const allActivities: Activity[] = []

		for (const timesheet of newTimeSheets) {
			if (timesheet.activities && timesheet.activities.length > 0) {
				const activitiesWithTimesheetId = timesheet.activities.map((activity) => ({
					...activity,
					timesheetId: timesheet.id,
				}))
				allActivities.push(...activitiesWithTimesheetId)
			}
		}

		const cleanTimeSheets = newTimeSheets.map((timesheet) => ({
			...timesheet,
			activities: [],
		}))

		await db.transaction('rw', [db.timesheets, db.timeRecords], async () => {
			db.setHooksEnabled(false)
			await db.timesheets.clear()
			await db.timeRecords.clear()

			if (cleanTimeSheets.length > 0) {
				await db.timesheets.bulkAdd(cleanTimeSheets)
			}

			if (allActivities.length > 0) {
				await db.timeRecords.bulkAdd(allActivities)
			}
			db.setHooksEnabled(true)
		})
	} catch (error) {
		showErrorToast({
			message: 'Error mapping timesheets',
		})
	}
}
